export default __webpack_public_path__ + "static/media/tree3.e070a2bd.png";